import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'join',
})
export class JoinPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  public transform(
    items: string[],
    options?: {
      separator?: string;
      maxLength?: number;
      i18nKey?: string;
    },
  ): string {
    if (!items || !items.length) return '';

    const { separator = ', ', maxLength, i18nKey } = options ?? {};
    const translatedItems = items.map((item) =>
      this.translateService.instant(i18nKey ? `${i18nKey}.${item}` : item),
    );

    if (!maxLength || items.length <= maxLength) {
      return translatedItems.join(separator);
    }

    const visibleItems = translatedItems.slice(0, maxLength).join(separator);
    const remainingCount = items.length - maxLength;

    return `${visibleItems}, +${remainingCount}`;
  }
}
